import React, { useState } from 'react';
import { Drawer, List, ListItem, ListItemText } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import logo from "../pics/logo.png";
import '../App.css';
import BarChartIcon from '@mui/icons-material/BarChart';
import MemoryIcon from '@mui/icons-material/Memory';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import StreamIcon from '@mui/icons-material/Stream';
import InsightsIcon from '@mui/icons-material/Insights';
import MenuIcon from '@mui/icons-material/Menu';
import ManageAccountsSharpIcon from '@mui/icons-material/ManageAccountsSharp';

const drawerWidth = 300;
const collapsedWidth = 80;

export const SideNavBar = ({ isExpanded, setIsExpanded }) => {

    const buttonStyle = {
        fontFamily: "DM Sans, sans-serif",
        fontWeight: "700",
        fontSize: "large",
        margin: "5px 0px",
    }

    const buttonColor = {
        color: "#a3aed0",
        marginBottom: "10px",
        "&:hover": {
            //   backgroundColor: "#e3e1e1",
            backgroundColor: "#dfe9fade",
            color: "#0b7ae3",
            borderRadius: "8px"
            //   cursor: "pointer",
        }
    }

    const iconStyle = {
        fontSize: 30,
        color: "inhirite",
        verticalAlign: "bottom",
        transition: 'margin-right 0.3s',
        marginRight: isExpanded ? `15px` : `23px`,
    }

    const drawerStyle = {
        width: drawerWidth,
        flexShrink: 0, mt: 8, border: "none",
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', border: "0 solid #e9ecef" },
    }

    const imageStyle = {
        width: '150px',
        height: 'auto',
        position: 'relative',
        left: '30px',
        top: '20px'
    }

    //   const [isExpanded, setIsExpanded] = useState(false);
//   const [selected, setSelected] = useState(null);

  const handleMouseEnter = () => {
    setIsExpanded(true);
  };

  const handleMouseLeave = () => {
    setIsExpanded(false);
  };

    return (
        <Drawer   variant="permanent"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      PaperProps={{
        sx: {
          width: isExpanded ? drawerWidth : collapsedWidth,
          transition: 'width 0.3s',
          overflowX: 'hidden',
          whiteSpace: 'nowrap',
          boxSizing: 'border-box',
        //   backgroundColor: '#263238',
        //   color: '#fff',
        },
      }}
        >
            <div style={{ padding: '16px', }}>
                <MenuIcon sx={{marginLeft:"10px", fontSize:"30px"}}/>
                <img src={logo} alt="Sidebar Image" style={imageStyle} />
            </div>

            <List sx={{ mt: 2, margin: "10px" }} >
                <ListItem component={NavLink} to="/" sx={buttonColor}>
                    <div style={buttonStyle}><StreamIcon sx={[iconStyle, {color: "blue"}]} /><span>Problem Formulation</span></div>
                </ListItem>

                <ListItem component={NavLink} to="/surrogate-generation" sx={buttonColor}>

                    <div style={buttonStyle}><ViewInArIcon sx={[iconStyle, {color: "#1daa07"}]} /><span>Surrogate Generation</span></div>
                </ListItem>

                <ListItem component={NavLink} to="/performance-plots" sx={buttonColor}>

                    <div style={buttonStyle}><InsightsIcon sx={[iconStyle, {color: "#ff9708"}]} /><span>Performance Plots</span></div>
                </ListItem>

                <ListItem component={NavLink} to="/optimization" sx={buttonColor}>

                    <div style={buttonStyle}><MemoryIcon sx={[iconStyle, {color: "#561299"}]} /><span>Optimization</span></div>
                </ListItem>

                <ListItem component={NavLink} to="/manage-models" sx={buttonColor}>

                    <div style={buttonStyle}><ManageAccountsSharpIcon sx={[iconStyle, {color: "#3291e1"}]} /><span>Manage Models</span></div>
                </ListItem>
            </List>
        </Drawer>
    )

}